import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { CustomCard } from "../CustomCard";
import { useVerticalNav } from "../../../Contexts/VerticalNavContext";
import { useSelectedTheme, useTranslate } from "../../../Hooks";
import { CustomAutocomplete } from "../CustomAutocomplete";
import { CustomButton } from "../CustomButton";
import { CustomRadioButton } from "../CustomRadioButton";
import { lookupItemsGetId, QuickAddContact } from "../../../Services";
import {
  CityTypeIdEnum,
  CommunityTypeIdEnum,
  ContactClassIdEnum,
  DistrictTypeIdEnum,
  LanguageEnum,
  NationalityEnum,
  SalutationEnum,
} from "../../../Enums";
import { CustomInput } from "../CustomInput";
import { PhoneNumberInput } from "../PhoneNumberInput";
import { CustomBadge, EmailInput } from "../..";

// styles
import useStyles from "./styles";

const QuickAddIndividualView = ({}) => {
  const styles = useStyles();
  const { translate } = useTranslate("NewContactsView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const { addNewContact, setAlertBoxContent } = useVerticalNav();
  const [contactClassOptions, setContactClassOptions] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const reducerAddContact = useCallback((state, action) => {
    if (action.id !== "edit") {
      return { ...state, [action.id]: action.value };
    } else {
      return action.value;
    }
  }, []);
  const requiredFields = [
    "firstName",
    "lastName",
    "salutationId",
    "nationalityId",
    "countryId",
    "cityId",
    "districtId",
    "communityId",
    "contactClassId",
  ];

  const [selected, setSelected] = useReducer(reducerAddContact, {
    Title: null,
    AssignedTo: null,
    Nationality: null,
    Country: null,
    City: null,
    District: null,
    Community: null,
    Language: null,
    ContactClass: null,
    phoneNumber: null,
    email: null,
  });
  const [saveDto, setSaveDto] = useReducer(reducerAddContact, {
    contactsTypeId: 1,
    firstName: addNewContact?.contact?.firstName,
    lastName: addNewContact?.contact?.lastName,
    salutationId: null,
    emailAddress: [addNewContact?.contact?.email],
    phoneNumber: [addNewContact?.contact?.phone],
    nationalityId: "",
    countryId: 0,
    cityId: 0,
    districtId: 0,
    communityId: 0,
    postalZipCode: "",
    data_completed: 16,
    contactClassId: null,
    languageId: null,
  });

  const [formData, setFormData] = useReducer(reducerAddContact, {
    nationalities: [],
    languages: [],
    contactClasses: [],
    countries: [],
    cities: [],
    discrities: [],
    community: [0],
    salutation: [],
  });

  const getAllContactClass = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: ContactClassIdEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200))
      setFormData({
        id: "contactClasses",
        value: res.map((item) => ({
          id: item?.lookupItemId,
          name: item?.lookupItemName,
          code: item?.lookupItemCode,
        })),
      });
    else
      setFormData({
        id: "contactClasses",
        value: [],
      });
  }, []);

  const GetSalutations = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: SalutationEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "salutation",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
        })),
      });
    } else
      setFormData({
        id: "salutation",
        value: [],
      });
  }, []);

  const getAllLanguages = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: LanguageEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200))
      setFormData({
        id: "languages",
        value: res.map((item) => ({
          id: item?.lookupItemId,
          name: item?.lookupItemName,
          code: item?.lookupItemCode,
        })),
      });
    else
      setFormData({
        id: "languages",
        value: [],
      });
  }, []);

  const GetNationalities = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: NationalityEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "nationalities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "nationalities",
        value: [],
      });
  }, []);

  const GetCountries = useCallback(async () => {
    const res = await lookupItemsGetId({
      lookupTypeId: NationalityEnum.lookupTypeId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "countries",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "countries",
        value: [],
      });
  }, []);

  const GetCities = useCallback(async (countryId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: CityTypeIdEnum.lookupTypeId,
      lookupParentId: countryId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "cities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "cities",
        value: [],
      });
  }, []);

  const GetDistrict = useCallback(async (cityId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: DistrictTypeIdEnum.lookupTypeId,
      lookupParentId: cityId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "discrities",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "discrities",
        value: [],
      });
  }, []);

  const GetCommunity = useCallback(async (districtId) => {
    const res = await lookupItemsGetId({
      lookupTypeId: CommunityTypeIdEnum.lookupTypeId,
      lookupParentId: districtId,
    });

    if (!(res && res.status && res.status !== 200)) {
      setFormData({
        id: "community",
        value: res.map((item) => ({
          id: item.lookupItemId,
          name: item.lookupItemName,
          code: item.lookupItemCode,
        })),
      });
    } else
      setFormData({
        id: "community",
        value: [],
      });
  }, []);

  const formatContactClass = () => {
    const formatted = formData.contactClasses.reduce((acc, item) => {
      const key = item.name.toLowerCase();
      acc[key] = { key: item.id, value: item.name };
      return acc;
    }, {});
    setContactClassOptions(formatted);
  };

  const handleContactClassChange = (value) => {
    setSaveDto({
      id: "contactClassId",
      value: value,
    });
  };

  const isDisabled = () => {
    return (
      !saveDto.nationalityId?.toString().trim() ||
      !saveDto.contactClassId ||
      !saveDto.salutationId ||
      isSubmit
    );
  };

  const restCounryRelatedChange = () => {
    setSelected({
      id: "City",
      value: null,
    });
    setSelected({
      id: "District",
      value: null,
    });
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "cityId",
      value: null,
    });
    setSaveDto({
      id: "districtId",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };

  const restCityRelatedChange = () => {
    setSelected({
      id: "District",
      value: null,
    });
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "districtId",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };

  const restDistrictRelatedChange = () => {
    setSelected({
      id: "Community",
      value: null,
    });
    setSaveDto({
      id: "communityId",
      value: null,
    });
  };

  const addIndividualContact = useCallback(async () => {
    setIsSubmit(true);
    try {
      const result = await QuickAddContact({
        ...saveDto,
        phoneNumber: [addNewContact?.contact?.phone],
        emailAddress: [addNewContact?.contact?.email],
      });
      if (!(result && result.data)) {
        setAlertBoxContent({
          display: true,
          variant: "success",
          title: "Contact added successfully!",
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      } else {
        setAlertBoxContent({
          display: true,
          variant: "error",
          title: "Something went wrong!",
          onClose: () => {
            setAlertBoxContent(null);
          },
        });
      }
    } catch (error) {
      console.error("some thing wrong !", error);
    } finally {
      setIsSubmit(false);
    }
  }, [saveDto]);

  useEffect(() => {
    getAllContactClass();
    GetSalutations();
    getAllLanguages();
    GetCountries();
    GetNationalities();
  }, [
    getAllContactClass,
    GetSalutations,
    getAllLanguages,
    GetNationalities,
    GetCountries,
  ]);

  useEffect(() => {
    formatContactClass();
  }, [formData]);

  useEffect(() => {
    const filledCount = requiredFields.filter((key) => {
      const value = saveDto[key];
      return value !== null && value !== undefined && value !== "" && value !== 0;
    }).length;
  
    const percentage = Math.round((filledCount / requiredFields.length) * 100);
  
    if (saveDto.data_completed !== percentage) {
      setSaveDto({
        id: "data_completed",
        value: percentage,
      });
    }
  }, [saveDto, setSaveDto]);

  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      <Box className={styles.headerQuickAddIndividualView}>
        <Box className={styles.containerPercentageTitle}>
          <Typography className={styles.titleHeaderItem}>
            {translate("Quick-Add")}
          </Typography>
          <CustomBadge
            label={`${saveDto.data_completed}%`}
            SizeVariant={"small"}
            BackgroundColor={palette.utility["brand_50"]}
            BorderColor={palette.utility["brand_200"]}
            Color={palette.utility["brand_700"]}
          />
        </Box>
        <CustomButton
          type="submit"
          variant="contained"
          color="primary"
          onClick={() => {
            addIndividualContact();
          }}
          disabled={isDisabled()}
        >
          {translate("Save")}
        </CustomButton>
      </Box>
      <CustomCard
        borderRadius="xl"
        boxShadow="xs"
        borderColor="secondary"
        classes={styles.wrapperQuickAddIndividualView}
      >
        <Typography className={styles.titleHeaderItem}>
          {translate("Personal-info")}
        </Typography>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("First-name")}*
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomInput
              style={{ maxWidth: "100%" }}
              hasSearchIcon={false}
              value={saveDto?.firstName}
              disabled
            />
          </Box>
        </Box>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Last-name")}*
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomInput
              style={{ maxWidth: "100%" }}
              hasSearchIcon={false}
              value={saveDto?.lastName}
              disabled
            />
          </Box>
        </Box>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Title")}*
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.salutation && formData.salutation.length > 0
                  ? formData.salutation
                  : []
              }
              value={selected?.Title || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "Title",
                  value: value,
                });
                setSaveDto({
                  id: "salutationId",
                  value: value?.id || null,
                });
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Contact-Class")}*
          </Typography>
          <Box className={styles.wrapperRadioButtons}>
            <CustomRadioButton
              checked={
                saveDto?.contactClassId === contactClassOptions?.normal?.key
              }
              onChange={(event) => {
                const newValue = Number(event.target.value);
                handleContactClassChange(newValue);
              }}
              label={contactClassOptions?.normal?.value}
              value={contactClassOptions?.normal?.key}
            />
            <CustomRadioButton
              checked={
                saveDto?.contactClassId === contactClassOptions?.vip?.key
              }
              onChange={(event) => {
                const newValue = Number(event.target.value);
                handleContactClassChange(newValue);
              }}
              label={contactClassOptions?.vip?.value}
              value={contactClassOptions?.vip?.key}
            />
            <CustomRadioButton
              checked={
                saveDto?.contactClassId === contactClassOptions?.vvip?.key
              }
              onChange={(event) => {
                const newValue = Number(event.target.value);
                handleContactClassChange(newValue);
              }}
              label={contactClassOptions?.vvip?.value}
              value={contactClassOptions?.vvip?.key}
            />
          </Box>
        </Box>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Nationality")}*
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.nationalities && formData.nationalities.length > 0
                  ? formData.nationalities
                  : []
              }
              value={selected?.Nationality || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "Nationality",
                  value: value,
                });
                setSaveDto({
                  id: "nationalityId",
                  value: value?.id || null,
                });
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Language")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.languages && formData.languages.length > 0
                  ? formData.languages
                  : []
              }
              value={selected?.Language || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "Language",
                  value: value,
                });
                setSaveDto({
                  id: "languageId",
                  value: value?.id,
                });
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>

        <Typography className={styles.titleHeaderItem}>
          {translate("Contact-Info")}
        </Typography>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Mobile")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <Box className={styles.phoneInputSection}>
              <PhoneNumberInput
                name="landlineRef"
                idRef="landlineRef"
                isDisabled={true}
                inputPlaceholder="+1 (555) 000-0000"
                value={saveDto?.phoneNumber?.[0]}
                country="ae"
                onInputChanged={(value) => {}}
              />
            </Box>
          </Box>
        </Box>

        <Divider />

        <Box className={styles.containerItemFiled}>
          <Box className={styles.containerEmailTitle}>
            <Typography className={styles.titleFiledItem}>
              {translate("Email-address")}
            </Typography>
            <Typography className={styles.sunTitleEmail}>
              {translate("Invoices-will-be-sent-to-this-email-address")}
            </Typography>
          </Box>
          <Box className={styles.wrapperInputFiled}>
            <EmailInput
              Style={{ width: "100%" }}
              idRef={"email-ref"}
              isDisabled={true}
              value={saveDto?.emailAddress[0]}
              onInputBlur={(e) => {}}
              inputPlaceholder="mail@domain.com"
              onInputChanged={(event) => {}}
            />
          </Box>
        </Box>

        <Typography className={styles.titleHeaderItem}>
          {translate("Residence-address")}
        </Typography>
        <Divider />

        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Country")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData?.countries && formData.countries.length > 0
                  ? formData?.countries
                  : []
              }
              value={selected?.Country || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "Country",
                  value: value,
                });
                setSaveDto({
                  id: "countryId",
                  value: value?.id,
                });
                restCounryRelatedChange();

                if (value) GetCities(value?.id);
                else {
                  setFormData({
                    id: "cities",
                    value: [],
                  });
                  restCounryRelatedChange();
                }
              }}
              getOptionLabel={(option) => (option && option?.name) || ""}
              getOptionValue={(option) => (option && option?.id) || ""}
            />
          </Box>
        </Box>
        <Divider />
        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("City")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.cities && formData.cities.length > 0
                  ? formData.cities
                  : []
              }
              value={selected?.City || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "City",
                  value: value,
                });
                setSaveDto({
                  id: "cityId",
                  value: value?.id,
                });
                restCityRelatedChange();
                if (value) GetDistrict(value?.id);
                else {
                  setFormData({
                    id: "discrities",
                    value: [],
                  });
                  restCityRelatedChange();
                }
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>
        <Divider />
        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("District")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.discrities && formData.discrities.length > 0
                  ? formData.discrities
                  : []
              }
              value={selected?.District || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "District",
                  value: value,
                });
                setSaveDto({
                  id: "districtId",
                  value: value?.id,
                });
                restDistrictRelatedChange();
                if (value) GetCommunity(value?.id);
                else {
                  setFormData({
                    id: "community",
                    value: [],
                  });
                  restDistrictRelatedChange();
                }
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>
        <Divider />
        <Box className={styles.containerItemFiled}>
          <Typography className={styles.titleFiledItem}>
            {translate("Community")}
          </Typography>
          <Box className={styles.wrapperInputFiled}>
            <CustomAutocomplete
              options={
                formData.community && formData.community.length > 0
                  ? formData.community
                  : []
              }
              value={selected?.Community || null}
              placeholder={`Select value`}
              onChange={(e, value) => {
                setSelected({
                  id: "Community",
                  value: value,
                });
                setSaveDto({
                  id: "communityId",
                  value: value?.id,
                });
              }}
              getOptionLabel={(option) => (option && option.name) || ""}
              getOptionValue={(option) => (option && option.id) || ""}
            />
          </Box>
        </Box>
      </CustomCard>
    </Box>
  );
};

export default QuickAddIndividualView;
